<!-- <app-header *ngIf="isVisible" [menuLinks]="menuLinks" [hamburgerMenu]="hamburgerMenu" [branch_locator]="branch_locator"
    [request_callback]="request_callback" [tollfree_number]="tollfree_number" [tollfree_2]="tollfree_number_2"
    [display_tollfree_sec]="display_tollfree_2"></app-header> -->

<app-bajaj-header *ngIf="isVisible"></app-bajaj-header>

<router-outlet></router-outlet>

<app-footer *ngIf="IsfooterVisible" [menuLinks]="footerLinks" [contactLinks]="contactLinks" [desc]="footer_desc"
    [tollfree]="tollfree_number" [tollfree_2]="tollfree_number_2" [display_tollfree_sec]="display_tollfree_2">
</app-footer>